package com.zi.support.shared

/** What an empty list says, the same on Android, iOS and web. Each client pairs it with its own icon. */
data class EmptyState(val title: String, val body: String)

object EmptyStates {
    val meetings = EmptyState("No meetings scheduled", "Create a meeting when the team needs to coordinate.")
    val openIssues = EmptyState("All clear", "No open issues right now. New reports from the apps show up here.")
    val resolvedIssues = EmptyState("No resolved issues yet", "Issues you resolve are kept here for reference.")
    val siteVisits = EmptyState("No site visits yet", "Site visits are created from an assigned ticket.")
    val checklists = EmptyState("No checklists yet", "Completed checklists show up here, ready to view or share.")

    /** A search or filter hid everything: [noun] is plural, e.g. "meetings". */
    fun noMatches(noun: String) = EmptyState("No matching $noun", "Try a different search or clear the filters.")
}
